<template>
  <div style="">
    <el-card style="margin-bottom: 20px">
      <div class="flex-between">
        <div class="flex">
          <div class="tui-img">
            <img
              :src="
                DataInfo.Sex == '男'
                  ? 'http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-26/20221226160803_5774.png'
                  : 'http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-26/20221226160817_3601.png'
              "
              alt=""
            />
          </div>
          <div class="tui-box">
            <div class="flex-items tui-userInfo">
              <div class="name">{{ DataInfo.StudentName }}</div>
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-26/20221226161123_9479.png"
                alt=""
              />
              <div class="age">{{ DataInfo.Age }}</div>
              <div class="tui-picker" @click="onClickPicker">{{ Time }}</div>
            </div>
            <div class="flex" style="padding-top: 5px">
              <div
                class="tui-bages"
                v-for="(cc, nn) in labelInfos"
                :key="nn"
                :style="getColors(cc.Status)"
              >
                {{ cc.Name }}
              </div>
            </div>
          </div>
        </div>

        <!-- 按钮 -->
        <div class="flex">
          <el-button round icon="el-icon-arrow-left" @click="$router.go(-1)"
            >返回首页</el-button
          >
          <el-button round type="goon" icon="el-icon-download"
            >下载报告</el-button
          >
        </div>
      </div>
    </el-card>
    <div style="height: 9.5rem; overflow-y: scroll">
      <div class="flex">
        <el-card class="tui-card">
          <div class="tui-step">步数</div>
          <div style="position: relative">
            <div class="circle-item">
              <div id="echartsPie" style="width: 200px; height: 200px"></div>
              <div class="tui-position">
                <div class="">
                  <img
                    style="width: 30px; height: 30px"
                    src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-27/20221227135400_6482.png"
                    alt=""
                  />
                </div>
                <div style="font-size: 24px">{{ DataInfo.Step }}</div>
              </div>
            </div>
            <div class="tui-positionRight">
              <div class="">
                行走距离 <span>{{ DataInfo.Distance }}</span
                >公里
              </div>
              <div style="padding-top: 50rpx">
                消耗热量 <span>{{ DataInfo.Quantity }}</span
                >千卡
              </div>
            </div>
          </div>
          <el-divider></el-divider>
          <div class="tui-step">心率</div>
          <div style="position: relative">
            <div class="circle-item">
              <!-- <canvas id="circle" width="200px" height="200px"> </canvas> -->

              <el-progress
                type="dashboard"
                :percentage="getNumData(Number(DataInfo.Heart))"
                :show-text="false"
                :color="
                  DataInfo.HeartColorStatus == 1
                    ? '#3FD4B7'
                    : DataInfo.HeartColorStatus == 2
                    ? '#FFBF4E'
                    : '#FE736D'
                "
                :stroke-width="10"
              ></el-progress>
              <div class="tui-position">
                <div class="">
                  <img
                    style="width: 30px; height: 30px"
                    src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-12/2022-12-22/20221222170718_3507.png"
                    alt=""
                  />
                </div>
                <div style="font-size: 24px">{{ DataInfo.Heart }}</div>
                <div style="font-size: 14px; color: #f3463a">
                  {{ DataInfo.HeartStatus }}
                </div>
              </div>
            </div>
            <div class="tui-positionRight">
              <div class="">
                平均心率 <span>{{ DataInfo.AvgHeart }}</span
                >次/分
              </div>
              <div class="">
                最低心率 <span>{{ DataInfo.LowHeart }}</span
                >次/分
              </div>
              <div style="padding-top: 50rpx">
                最高心率 <span>{{ DataInfo.HighHeart }}</span
                >次/分
              </div>
            </div>
          </div>
          <div class="flex-between">
            <div class="tui-step">睡眠</div>
          </div>
          <div
            v-show="
              DataInfo.SleepListSeries && DataInfo.SleepListSeries.length != 0
            "
          >
            <div id="echartsSleep" style="width: 480px; height: 300px"></div>
          </div>
          <el-empty
            description="暂无数据"
            v-if="
              DataInfo.SleepListSeries && DataInfo.SleepListSeries.length == 0
            "
          ></el-empty>
        </el-card>
        <div class="flex tui-rightCard">
          <el-card style="margin-bottom: 0.25rem">
            <div slot="header" class="tui-text">
              <span>心率曲线走势图</span>
            </div>
            <div id="echartsHeart" style="width: 100%; height: 300px"></div>
          </el-card>
          <div class="flex">
            <el-card class="flexW" style="margin-right: 0.25rem">
              <div style="padding-bottom: 50px">
                <div slot="header" class="tui-text">
                  <span>数据对比</span>
                  <div class="tui-textRight"></div>
                </div>
                <el-table
                  :data="DataContrast.SportList"
                  style="width: 100%"
                  :header-cell-style="{
                    background: '#FAFAFA',
                    color: '#333',
                    'text-align': 'center',
                  }"
                >
                  <el-table-column prop="Name" label="统计值" align="center">
                  </el-table-column>
                  <el-table-column
                    prop="StandardNum"
                    label="该生数值"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <div>
                        {{
                          scope.row.Name == "步数"
                            ? scope.row.RealNum + "步"
                            : scope.row.Name == "行走距离"
                            ? scope.row.RealNum + "公里"
                            : scope.row.Name == "消耗热量"
                            ? scope.row.RealNum + "千卡"
                            : scope.row.Name == "睡眠"
                            ? scope.row.RealNum + "分钟"
                            : scope.row.RealNum + "次/分"
                        }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="结果" align="center">
                    <template slot-scope="scope">
                      <div
                        :style="getColors(scope.row.Status)"
                        v-if="
                          scope.row.Name == '最低心率' ||
                          scope.row.Name == '最高心率'
                        "
                      >
                        {{
                          scope.row.Status == 1 ? "正常" : scope.row.StandardNum
                        }}
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-card>
            <el-card class="flexW">
              <div style="padding-bottom: 50px">
                <div slot="header" class="tui-text">
                  <span>异常记录</span>
                </div>
                <el-table
                  :data="showList"
                  :header-cell-style="{
                    background: '#FAFAFA',
                    color: '#333',
                    'text-align': 'center',
                  }"
                  style="width: 100%"
                >
                  <el-table-column label="理由" align="center">
                    <template slot-scope="scope">
                      <div class="tui-tags">{{ scope.row.Reason }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="RealNum" label="监测值" align="center">
                  </el-table-column>
                  <el-table-column prop="Time" label="异常时间" align="center">
                  </el-table-column>
                </el-table>
                <div
                  class="tui-allData"
                  v-if="showList.length > 5"
                  @click="changeFoldState"
                >
                  {{ isOpen ? "查看全部数据" : "收起" }}
                  <i class="el-icon-arrow-down" style="color: #469bfd"></i>
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="选择日期" :visible.sync="dialogVisible" width="30%">
      <div>
        <SimpleCalendar
          :unavailableContractDate="unavailableContractDate"
          @onDayClick="onDayClick"
          :ClassId="Number($route.query.ClassId)"
          :StudentId="Number($route.query.StudentId)"
        ></SimpleCalendar>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetSportDateDedailByData,
  GetSportDateByData,
  GetDateClassStuBaseInfo,
} from "../../api/api";
import SimpleCalendar from "../../components/SimpleCalendar/SimpleCalendar.vue";

export default {
  components: {
    SimpleCalendar,
  },
  data() {
    return {
      tableData: [],
      DataInfo: {},
      tableData: [],
      DataContrast: {},
      isOpen: true, // 是否展开全部信息的标识 Boolean 默认false
      HeartList: [],
      labelInfos: [],
      timeData: [],
      Time: "",
      timer: null,
      dialogVisible: false,
      unavailableContractDate: [],
    };
  },
  async mounted() {
    this.labelInfos = JSON.parse(this.$route.query.labelInfos);

    await this.GetDateClassStuBaseInfo();
    await this.GetSportDateDedailByData();
    await this.GetSportDateByData();
    await this.getDataPie();
    await this.getDataSleep();
    await this.echartsHeart();
    this.timer = setInterval(async () => {
      //需要定时执行的代码
      await this.GetSportDateDedailByData();
      await this.GetSportDateByData();
      console.log("执行");
    }, 3000);
    // this.toCanvas("circle", this.DataInfo.Heart);
  },
  beforeRouteLeave(to, from, next) {
    console.log("离开路由");
    clearInterval(this.timer);
    next();
  },
  computed: {
    showList: {
      get: function () {
        if (this.isOpen) {
          if (this.HeartList.length < 7) {
            return this.HeartList;
          }
          let newArr = [];
          for (var i = 0; i < 6; i++) {
            let item = this.HeartList[i];
            newArr.push(item);
          }
          return newArr;
        }
        return this.HeartList;
      },
      set: function (val) {
        this.showList = val;
      },
    },
  },
  methods: {
    async onDayClick(e) {
      console.log(e);
      this.Time = e.date;
      await this.GetSportDateDedailByData();
      await this.GetSportDateByData();
      this.dialogVisible = false;
    },
    onClickPicker() {
      this.dialogVisible = true;
    },
    getNumData(val) {
      if (val) {
        return Math.round(val / 2);
      }
    },
    async onChangeTime(e) {
      this.Time = e;
      await this.GetSportDateDedailByData();
      await this.GetSportDateByData();
      await this.getDataPie();
      await this.getDataSleep();
      await this.echartsHeart();
      this.toCanvas("circle", this.DataInfo.Heart);
    },
    async GetDateClassStuBaseInfo() {
      console.log(this.$route.query.Time);
      let res = await GetDateClassStuBaseInfo({
        Id: this.$route.query.ClassId,
        Time: this.$route.query.Time,
        StudentId: this.$route.query.StudentId,
      });
      if (res.data.success) {
        this.unavailableContractDate = res.data.response;
        this.timeData = res.data.response.filter((cc) => cc.Disable);
        this.Time = this.timeData[0].Time;
      }
    },
    changeFoldState() {
      this.isOpen = !this.isOpen;
    },
    // 数据对比
    async GetSportDateByData() {
      let res = await GetSportDateByData({
        Time: this.Time,
        StudentId: this.$route.query.StudentId,
      });
      if (res.data.success) {
        this.DataContrast = res.data.response;
      }
    },
    async GetSportDateDedailByData() {
      let res = await GetSportDateDedailByData({
        Time: this.Time,
        StudentId: this.$route.query.StudentId,
      });
      if (res.data.success) {
        this.DataInfo = res.data.response;
        this.HeartList = res.data.response.HeartList;
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    async echartsHeart() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("echartsHeart"));
      // 绘制图表
      myChart.setOption({
        xAxis: {
          type: "category",
          data: this.DataInfo.HeartHourxAxis,
        },
        dataZoom: [
          {
            orient: "horizontal",
            show: this.zoomShow, //控制滚动条显示隐藏
            realtime: true, //拖动滚动条时是否动态的更新图表数据
            height: 15, //滚动条高度
            start: 0, //滚动条开始位置（共100等份）
            end: this.endValue, //滚动条结束位置
            bottom: "4%",
            zoomLock: true, //控制面板是否进行缩放
          },

          {
            type: "inside",
            brushSelect: true,
            start: 0,
            end: 100,
            xAxisIndex: [0],
          },
        ],

        yAxis: {
          type: "value",
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: "none",
            },
            dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            restore: {},
            saveAsImage: {},
          },
        },
        color: ["#F7B709", "#5AD8A6", "#5B8FF9"],
        series: [
          {
            data: this.DataInfo.HeartHourSeries,
            type: "line",
            smooth: true,
          },
        ],
      });
    },
    async getDataSleep() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("echartsSleep"));
      // 绘制图表
      myChart.setOption({
        xAxis: {
          type: "category",
          data: this.DataInfo.SleepListxAxis,
        },
        yAxis: {
          type: "value",
        },
        color: ["#3692FD"],
        series: [
          {
            data: this.DataInfo.SleepListSeries,
            type: "line",
            smooth: true,
            areaStyle: {
              normal: {
                color: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0.1,
                      color: "#3692FD", // 0% 处的颜色
                    },
                    {
                      offset: 0.5,
                      color: "rgba(54,146,253, 0.3)", // 0% 处的颜色
                    },
                    {
                      offset: 0.7,
                      color: "rgba(54,146,253, 0.1)", // 0% 处的颜色
                    },
                    {
                      offset: 0.9,
                      color: "rgba(255,255,255, 0.1)", // 100% 处的颜色
                    },
                  ],
                  globalCoord: false, // 缺省为 false
                },
              },
            },
          },
        ],
      });
    },
    async getDataPie() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("echartsPie"));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "item",
        },
        legend: {
          show: false,
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["70%", "80%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            color: ["#33CDFF", "#F6F6F6"],

            labelLine: {
              show: false,
            },
            data: [
              { value: Number(this.DataInfo.Step), name: "步数" },
              { value: Number(this.DataInfo.MaxStep), name: "最大步数" },
            ],
          },
        ],
      });
    },
    getColors(val) {
      if (val !== 1) {
        return {
          background: "#FFF9ED",
          color: "#FFBF4E",
        };
      } else {
        return {
          background: "#F1FFF9",
          color: "#59E295",
        };
      }
    },
  },
};
</script>
<style lang="less" scoped>
.tui-picker {
  width: 2.75rem;
  font-size: 0.175rem;
  height: 0.45rem;
  line-height: 0.45rem;
  padding-left: 0.1875rem;
  border: 1px solid #dcdfe6;
  background-color: #fff;
  color: rgb(192, 196, 204);
  border-radius: 5px;
  cursor: pointer;
  margin-left: 0.25rem;
}
.tui-allData {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #469bfd;
  font-size: 14px;
  padding: 10px 0 20px 0;
  cursor: pointer;
}
/deep/.el-progress-circle {
  width: 2.5rem !important;
  height: 2.5rem !important;
}
.tui-textRight {
  float: right;
  padding: 3px 0;
  font-size: 0.175rem;
  color: #999;
  font-weight: 500;
  span {
    color: #27abf7;
  }
}
.tui-tags {
  padding: 0 0.125rem;
  height: 0.325rem;
  background: rgba(254, 115, 109, 0.1);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fe736d;
  font-size: 0.175rem;
}
.tui-card {
  flex: 1;
  margin-right: 0.25rem;
  background: #fbfbfb;
  padding-bottom: 0.625rem;
}
.tui-text {
  font-size: 18px;
  color: #333;
  font-weight: bold;
}
.tui-position {
  position: absolute;
  text-align: center;
  top: 35%;
  left: 0;
  right: 0;
}
.tui-positionRight {
  position: absolute;
  right: 0;
  top: 0.4375rem;
  display: flex;
  flex-direction: column;
  right: 0.375rem;

  div {
    color: #333;
    font-size: 0.225rem;
    padding: 0.1875rem 0;
  }

  span {
    color: #333;
    font-size: 0.3rem;
    font-weight: bold;
    padding: 0 0.0625rem;
  }
}
.circle-item {
  position: relative;
  width: 2.5rem;
}
.tui-step {
  color: #333;
  font-size: 0.225rem;
  font-weight: bold;
}
.flexW {
  flex: 1;
}
.tui-rightCard {
  flex-direction: column;
  flex: 2;
}
.tui-box {
  padding-left: 0.125rem;
  display: flex;
  flex-direction: column;
}
.el-button--goon {
  color: #fff;
  background-color: #27abf7;
  border-color: #27abf7;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
.tui-bages {
  padding: 0 0.125rem;
  height: 0.375rem;
  background: #f1fff9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.15rem;
  margin-right: 0.0875rem;
}
.tui-userInfo {
  .name {
    color: #333333;
    font-size: 0.25rem;
    font-weight: bold;
  }
  .age {
    color: #666666;
    font-size: 0.225rem;
  }
  img {
    width: 0.2625rem;
    height: 0.25rem;
    padding: 0 0.125rem;
  }
}
.tui-img {
  width: 0.775rem;
  height: 0.775rem;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>